import React, { useState } from 'react';
import { navigate, RouteComponentProps } from '@reach/router';
import { DateTime } from 'luxon';
import { CoreAccountTable } from './particles';
import { Box, Stack } from '@mui/material';

import { useCoreDashboard } from '@api';
import { DashboardHeader, BillingAccountSelector } from '@organisms';
import CardList from './particles/commonCard';
import { routes } from '@particles';

const NegotiatorDashboard: React.FC<RouteComponentProps> = () => {
  const [start, setStart] = useState<Date>(DateTime.local().minus({ days: 6 }).startOf('day').toJSDate());
  const [end, setEnd] = useState<Date>(DateTime.local().endOf('day').toJSDate());

  const { data: response, isFetching } = useCoreDashboard({
    startDate: DateTime.fromJSDate(start).toISO({
      suppressMilliseconds: true,
      includeOffset: false
    }),
    endDate: DateTime.fromJSDate(end).toISO({
      suppressMilliseconds: true,
      includeOffset: false
    })
  });

  return (
    <Stack sx={{ m: 2 }}>
      <Box sx={{ mt: 1, mb: 2 }}>
        <DashboardHeader
          start={start}
          end={end}
          onSelectRange={(start, end) => {
            setStart(start);
            setEnd(end);
          }}
        />
      </Box>
      <CardList loading={isFetching} dashboardCount={response?.data?.data} />
      <Box sx={{ mt: 2, mb: 2 }}>
        <CoreAccountTable startDate={start} endDate={end} />
      </Box>
    </Stack>
  );
};

export default NegotiatorDashboard;
